/**
 * 반입물품 관련 도우미 클래스
 */
class ImportItemHelper {
    /**
     * 반입물품 목록 헤더를 설정한다.
     * 백오피스 > 코드관리 service.config.import_item_columns 값을 이용하여 헤더를 재설정한다.
     *
     * @param originHeaders
     * @param fieldConfig
     */
    static cleanUnusedHeaders(originHeaders, fieldConfig) {
        const headers = originHeaders;
        if (headers && fieldConfig) {
            fieldConfig.forEach(field => {
                const index = headers.findIndex(header => header.value === field.column);
                if (index !== -1 && !field.enable) {
                    headers.splice(index, 1);
                }
            })
        }

        return headers;
    }

    /**
     * service.config.import_item_columns 값은 JSON으로 파싱
     *
     * @param importItemColumnConfig
     * @return {any|*[]}
     */
    static parseImportItemColumnsConfig(importItemColumnConfig) {
        try {
            return JSON.parse(importItemColumnConfig);
        } catch(err) {
            console.error(err);
            return [];
        }
    }
}

export default ImportItemHelper;